<template>
  <div>
    <b-card no-body>
      <b-card-header>
          <h3 class="float-left"><i class='fa fa-edit'></i> Rule</h3>
          <!-- <b-button variant="primary" class="float-right" @click="showModal">Create Rule</b-button> -->
      </b-card-header>
      <b-card-body>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <!-- <template v-slot:cell(action)="data">
            <b-button variant="warning" @click="editRule(data.item.Id)">Edit</b-button>
          </template> -->
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
    </b-card>
    <!-- <b-modal ref="editRule" size="lg" header-bg-variant="primary" hide-footer title="Edit Rule">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.eRuleName.$error && $v.eRuleParameter.$error)">
                      <label for="eRuleName">Name</label>
                      <b-form-input type="text" id="eRuleName" placeholder="Enter Rule Name" v-model.trim="eRuleName" :state="$v.eRuleName.$error?false:null" @focus.native="$v.eRuleName.$touch"></b-form-input>
                      <div v-if="$v.eRuleName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.eRuleName.required">Rule name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eRuleName.minLength">Must have at least {{ $v.eRuleName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.eRuleName.maxLength">Must not exceed {{ $v.eRuleName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="eRuleTypeName">Type</label>
                      <b-form-input type="text" readonly id="eRuleTypeName" placeholder="" v-model="eRuleTypeName"></b-form-input>

                      <label for="eRuleParameter">Setting</label>
                      <b-form-textarea id="eRuleParameter" v-model="eRuleParameter" placeholder="" :rows="5" :max-rows="9" :state="$v.eRuleParameter.$error?false:null" @focus.native="$v.eRuleParameter.$touch"></b-form-textarea>
                      <div v-if="$v.eRuleParameter.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.eRuleParameter.required">Setting is required</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="updateRule" :disabled="$v.eRuleName.$error || $v.eRuleParameter.$error">Update</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="closeEdit">Cancel</b-btn>
    </b-modal>
    <b-modal ref="createRule" size="lg" header-bg-variant="primary" hide-footer title="Create Rule">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.cRuleName.$error && $v.cRuleType.$error && $v.cRuleParameter.$error)">
                      <label for="cRuleName">Name</label>
                      <b-form-input type="text" id="cRuleName" placeholder="Enter Rule Name" v-model.trim="cRuleName" :state="$v.cRuleName.$error?false:null" @focus.native="$v.cRuleName.$touch"></b-form-input>
                      <div v-if="$v.cRuleName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cRuleName.required">Rule name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cRuleName.minLength">Must have at least {{ $v.cRuleName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cRuleName.maxLength">Must not exceed {{ $v.cRuleName.$params.maxLength.max}} letters</div>
                      </div>

                      <label for="cRuleType">Type</label>
                      <b-form-select id="cRuleType" :plain="false" v-model="cRuleType" :state="$v.cRuleType.$error?false:null" @blur.native="$v.cRuleType.$touch" @change="changeRuleType">
                        <option :value="null">Please select</option>
                        <option v-for="t in ruleTypes" :value="t.Id">{{ t.Name }}</option>
                      </b-form-select>
                      <div v-if="$v.cRuleType.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cRuleType.required">Type is required</div>
                      </div>

                      <label for="cRuleParameter">Setting</label>
                      <b-form-textarea id="cRuleParameter" v-model="cRuleParameter" placeholder="" :rows="5" :max-rows="9" :state="$v.cRuleParameter.$error?false:null" @focus.native="$v.cRuleParameter.$touch"></b-form-textarea>
                      <div v-if="$v.cRuleParameter.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cRuleParameter.required">Setting is required</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="createRule" :disabled="$v.cRuleName.$error || $v.cRuleType.$error || $v.cRuleParameter.$error">Create Rule</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal">Cancel</b-btn>
    </b-modal> -->
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'rule-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        ruleTypes: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'TypeName', label: 'Type'},
          {key: 'Parameter', label: 'Setting'}
          // {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        eRuleId: '',
        eRuleName: '',
        eRuleTypeName: '',
        eRuleParameter: '',
        cRuleName: '',
        cRuleType: '',
        cRuleParameter: ''
      }
    },
    validations: {
      eRuleName: { required, minLength: minLength(1), maxLength: maxLength(50) },
      eRuleParameter: { required },
      cRuleName: { required, minLength: minLength(1), maxLength: maxLength(50) },
      cRuleType: { required },
      cRuleParameter: { required }
    },
    watch: {
      currentPage: function () {
        this.getAllRules()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getAllRules () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/rule/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.rules
          this.totalRows = response.data.rules.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllRuleTypes () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/rule/type/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.ruleTypes = response.data.types
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      changeRuleType (selected) {
        this.ruleTypes.forEach(item => {
          if (item.Id === selected) {
            this.cRuleParameter = item.ParameterTemplate
          }
        })
      },
      updateRule () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/rule/update', {'id': this.eRuleId, 'name': this.eRuleName, 'parameter': this.eRuleParameter}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getAllRules()
            this.closeEdit()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Rule Updated')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      createRule () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/rule/add', {'name': this.cRuleName, 'type': this.cRuleType, 'parameter': this.cRuleParameter}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getAllRules()
            this.hideModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Rule Added')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      editRule (id) {
        this.items.forEach(item => {
          if (item.Id === id) {
            this.eRuleId = item.Id
            this.eRuleName = item.Name
            this.eRuleTypeName = item.TypeName
            this.eRuleParameter = item.Parameter
          }
        })
        this.$refs.editRule.show()
      },
      closeEdit () {
        this.$refs.editRule.hide()
      },
      showModal () {
        this.reset()
        this.$refs.createRule.show()
      },
      hideModal () {
        this.$refs.createRule.hide()
      },
      reset () {
        this.cRuleName = ''
        this.cRuleType = ''
        this.cRuleParameter = ''
      }
    },
    created () {
      this.getAllRules()
      this.getAllRuleTypes()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/rule/RuleTable.vue